import is from './is';

const checkIfLocalStorageExists = () => is.client() && Boolean(window.localStorage);

type Item = {
  value: string;
  expiry?: number;
};

class LocalStorage {
  static key = (n: number) => checkIfLocalStorageExists() && window.localStorage.key(n);

  static get = (key: string) => {
    if (checkIfLocalStorageExists()) {
      const item = window.localStorage.getItem(key);
      if (!item) return null;

      const { value, expiry } = JSON.parse(item);

      if (new Date().getTime() > expiry) {
        window.localStorage.removeItem(key);
        return null;
      }
      return value;
    }
    return null;
  };

  static set = (key: string, value: any, expiry?: number) => {
    if (checkIfLocalStorageExists()) {
      const item: Item = {
        value,
      };

      if (expiry) {
        item.expiry = new Date().getTime() + expiry;
      }

      let keyValue = value;
      if (is.not.string(value)) {
        keyValue = JSON.stringify(keyValue);
      } else {
        item.value = keyValue;
      }
      window.localStorage.setItem(key, JSON.stringify(item));
    }
  };

  static remove = (key: string) => {
    if (checkIfLocalStorageExists()) {
      window.localStorage.removeItem(key);
    }
  };

  static clear = () => {
    if (checkIfLocalStorageExists()) {
      window.localStorage.clear();
    }
  };
}

export default LocalStorage;
